export default {
	data(){
		return {
			tableGBoptions: { 
			},

			tableGBSearch: ['datos_afiliado/name'],
			
			tableGBItems: [
				{
					thead: { th: 'Titular', sort: null, sortTable: 'datos_afiliado/name'},
					tbody: { td: ['datos_afiliado/name'],}
				},
				{
					thead: { th: 'Nombre Documento', sort: null, sortTable: 'afiliado_documentos/name'},
					tbody: { td: ['afiliado_documentos/name'],}
				},
				{
					thead: { th: 'Archivo', },
					tbody: { td: ['afiliado_documentos/archivo'], link:'/files', archivo: true}
				},
				{
					thead: { th: 'Radicador', },
					tbody: { td: ['list_users/name'], ftn: function(value) { return value.split(' ')[0]}}
				},
			],			
		
		}
	},
}